export class Controller {

    /** @ngInject */
    constructor(AccountsResource) {
        this.AccountsResource = AccountsResource;
    }

    $onInit() {
    }

    remove() {
        this.isSaving = true;
        this.AccountsResource
            .removeAccountOwner(this.resolve.companyId, this.resolve.accountId)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/owner/remove/remove-account-owner.controller.js